module.exports = __webpack_public_path__ + "media/application/assets/fonts/lkwlat_icon_font-4b291d43023e2436280d59cbdf960e0b.woff";